module.exports = __webpack_public_path__ + "img/1m.376efdf4.jpg";